var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SamsungPayEventTypeEnumsObj } from "../enums/SamsungPayEventTypeEnum";
import { validateButtonParams } from "../models/SamsungPayButtonParams";
import { convertInitParams, validateInitParams } from "../models/SamsungPayInitParams";
import EventReporter from "./eventReporter/EventReporter";
import { samsungPayButtonBlackImg } from "../assets/svgImages";
import { samsungPayButtonWhiteImg } from "../assets/svgImages";
import { SamsungPayButtonColorEnumsObj } from "../enums/SamsungPayButtonColorEnum";
import SamsungPaySdkService from "./SamsungPaySdkService";
import { validateSamsungPayPaymentDetailsUpdate, } from "../models/SamsungPayPaymentDetailsUpdate";
import { getRandomString } from "../helpers/CommonFunctions";
import { BUILD_TYPE, SDK_VERSION } from "../models/SamsungPayVersion";
import { BaseEcomSdkEnumsObj } from "@payair/e-com-common-sdk";
/** @internal */
var eventReporter;
/** @internal */
var samsungPaySdkService;
/** @internal */
var paymentRequest;
/** @internal */
var samsungPayButtonId;
/** @internal */
var samsungPayInitParamsGlobal;
/** @internal */
var SamsungPaySdkImpl = /** @class */ (function () {
    function SamsungPaySdkImpl() {
        var _this = this;
        this.initSdk = function (samsungPayInitParams) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        samsungPayInitParamsGlobal = samsungPayInitParams;
                        return [4 /*yield*/, initSdkImpl(samsungPayInitParams, SamsungPayEventTypeEnumsObj.SDK_INITIALIZE_SUCCESS)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.renderButton = function (container, samsungPayButtonParams) {
            return renderButtonImpl(container, samsungPayButtonParams);
        };
        this.isReadyToPay = function (samsungPayInitParams) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, isReadyToPayImpl(samsungPayInitParams)];
        }); }); };
        this.startPayment = function () { return startPaymentImpl(); };
        this.isUserEligibleToMakePayment = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, isUserEligibleToMakePaymentImpl()];
        }); }); };
        this.getVersion = function () {
            return {
                sdk: BaseEcomSdkEnumsObj.PAYAIR_SAMSUNG_PAY_SDK,
                version: SDK_VERSION,
                buildType: BUILD_TYPE,
            };
        };
        eventReporter = new EventReporter();
    }
    return SamsungPaySdkImpl;
}());
export { SamsungPaySdkImpl };
/** @internal */
var initSdkImpl = function (samsungPayInitParams, successEvent) { return __awaiter(void 0, void 0, void 0, function () {
    var initParamsValidationResult, _a, samsungPayPaymentMethodData, samsungPayDetails, samsungPayOptions, isReadyToPay, callback_1, callback_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!window.PaymentRequest) {
                    eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.SDK_INITIALIZE_FAIL_DEVICE_NOT_ELIGIBLE, "This browser is not supported.");
                    return [2 /*return*/];
                }
                initParamsValidationResult = validateInitParams(samsungPayInitParams);
                if (initParamsValidationResult.length > 0) {
                    eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.SDK_INITIALIZE_FAIL_INIT_PARAMS_ERROR, initParamsValidationResult.join(", "));
                    return [2 /*return*/];
                }
                eventReporter.initEventReporterService(samsungPayInitParams.pspName, samsungPayInitParams.transactionId);
                _a = convertInitParams(samsungPayInitParams), samsungPayPaymentMethodData = _a[0], samsungPayDetails = _a[1], samsungPayOptions = _a[2];
                paymentRequest = new PaymentRequest(samsungPayPaymentMethodData, samsungPayDetails, samsungPayOptions);
                return [4 /*yield*/, isReadyToPayImpl()];
            case 1:
                isReadyToPay = _b.sent();
                if (!isReadyToPay) {
                    eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.SDK_INITIALIZE_FAIL_DEVICE_NOT_ELIGIBLE);
                    return [2 /*return*/];
                }
                samsungPaySdkService = new SamsungPaySdkService(samsungPayInitParams.pspName);
                if (typeof samsungPayInitParams.onShippingAddressChange === "function") {
                    callback_1 = samsungPayInitParams.onShippingAddressChange;
                    paymentRequest.addEventListener("shippingaddresschange", function (event) {
                        return onShippingAddressChange(event, callback_1, samsungPayDetails);
                    });
                }
                if (typeof samsungPayInitParams.onShippingOptionChange === "function") {
                    callback_2 = samsungPayInitParams.onShippingOptionChange;
                    paymentRequest.addEventListener("shippingoptionchange", function (event) {
                        return onShippingOptionChange(event, callback_2, samsungPayDetails);
                    });
                }
                eventReporter.sendEvent(successEvent);
                return [2 /*return*/];
        }
    });
}); };
/** @internal */
var onShippingAddressChange = function (event, onShippingAddressChange, samsungPayDetails) {
    if (!event || !event.target) {
        return;
    }
    var chosenShippingAddress = event.target["shippingAddress"];
    var samsungPayPaymentDetailsUpdate = onShippingAddressChange(chosenShippingAddress, samsungPayDetails);
    var validationResult = validateSamsungPayPaymentDetailsUpdate(samsungPayPaymentDetailsUpdate);
    if (validationResult !== null) {
        throw new Error(validationResult);
    }
    event.updateWith(samsungPayPaymentDetailsUpdate);
};
/** @internal */
var onShippingOptionChange = function (event, onShippingOptionChange, samsungPayDetails) {
    if (!event || !event.target) {
        return;
    }
    var chosenShippingOptionId = event.target["shippingOption"];
    var samsungPayPaymentDetailsUpdate = onShippingOptionChange(chosenShippingOptionId, samsungPayDetails);
    var validationResult = validateSamsungPayPaymentDetailsUpdate(samsungPayPaymentDetailsUpdate);
    if (validationResult !== null) {
        throw new Error(validationResult);
    }
    if (samsungPayPaymentDetailsUpdate.shippingOptions) {
        for (var _i = 0, _a = samsungPayPaymentDetailsUpdate.shippingOptions; _i < _a.length; _i++) {
            var shippingOption = _a[_i];
            if (shippingOption.id === chosenShippingOptionId) {
                shippingOption.selected = true;
            }
            else {
                shippingOption.selected = false;
            }
        }
    }
    event.updateWith(samsungPayPaymentDetailsUpdate);
};
/** @internal */
var isReadyToPayImpl = function (samsungPayInitParams) { return __awaiter(void 0, void 0, void 0, function () {
    var isReadyToPayPaymentRequest, initParamsValidationResult, _a, samsungPayPaymentMethodData, samsungPayDetails, samsungPayOptions;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!window.PaymentRequest) {
                    eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.IS_READY_TO_PAY_ERROR, "This browser is not supported.");
                    return [2 /*return*/, false];
                }
                isReadyToPayPaymentRequest = undefined;
                if (samsungPayInitParams) {
                    initParamsValidationResult = validateInitParams(samsungPayInitParams);
                    if (initParamsValidationResult.length > 0) {
                        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.IS_READY_TO_PAY_ERROR, initParamsValidationResult.join(", "));
                        return [2 /*return*/, false];
                    }
                    _a = convertInitParams(samsungPayInitParams), samsungPayPaymentMethodData = _a[0], samsungPayDetails = _a[1], samsungPayOptions = _a[2];
                    isReadyToPayPaymentRequest = new PaymentRequest(samsungPayPaymentMethodData, samsungPayDetails, samsungPayOptions);
                }
                else if (paymentRequest) {
                    isReadyToPayPaymentRequest = paymentRequest;
                }
                else {
                    eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.IS_READY_TO_PAY_ERROR, "Call initSdk() or pass samsungPayInitParams.");
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, isReadyToPayPaymentRequest
                        .canMakePayment()
                        .then(function (result) {
                        if (result) {
                            return result;
                        }
                        return false;
                    })
                        .catch(function (error) {
                        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.IS_READY_TO_PAY_ERROR, error);
                        return false;
                    })];
            case 1: return [2 /*return*/, _b.sent()];
        }
    });
}); };
/** @internal */
var renderButtonImpl = function (container, samsungPayButtonParams) {
    var buttonContainer = document.getElementById(container);
    if (!buttonContainer) {
        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.BUTTON_RENDER_FAIL_BUTTON_CONTAINER_DOESNT_EXISTS);
        return;
    }
    var buttonParamsValidationResult = validateButtonParams(samsungPayButtonParams);
    if (buttonParamsValidationResult.length > 0) {
        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.BUTTON_RENDER_FAIL_BUTTON_PARAMS_ERROR, buttonParamsValidationResult.join(", "));
        return;
    }
    var existingButtonElement = buttonContainer.querySelector("samsung-pay-button");
    if (!existingButtonElement) {
        var samsungPayButtonWebComponent = document.createElement("samsung-pay-button");
        samsungPayButtonWebComponent.style.display = "inline-block";
        var samsungPayButton = document.createElement("button");
        samsungPayButton.style.border = "none";
        samsungPayButton.style.background = "none";
        samsungPayButton.style.margin = "0";
        samsungPayButton.style.padding = "0";
        samsungPayButton.style.cursor = "pointer";
        samsungPayButton.onclick = function () { return samsungPayButtonOnClick(samsungPayButtonParams.buttonOnClick); };
        var samsungPayImg = samsungPayButtonBlackImg;
        switch (samsungPayButtonParams.buttonColor) {
            case SamsungPayButtonColorEnumsObj.BLACK:
                break;
            case SamsungPayButtonColorEnumsObj.WHITE:
                samsungPayImg = samsungPayButtonWhiteImg;
                break;
        }
        var samsungPayImgCssText = "\n      .samsung-pay-button svg{\n        width: 120px;\n        vertical-align: bottom;\n      }\n    ".replace(/(\r\n|\n|\r|\  )(?!screen)(?!and)(?!\()/gm, "");
        var styleElement = document.createElement("style");
        styleElement.innerText = samsungPayImgCssText;
        samsungPayButtonWebComponent.appendChild(styleElement);
        samsungPayButton.className = "samsung-pay-button";
        samsungPayButton.innerHTML = samsungPayImg;
        var samsungPayButtonIdLocal = "samsungPayButton-".concat(getRandomString());
        samsungPayButton.id = samsungPayButtonIdLocal;
        samsungPayButtonId = samsungPayButtonIdLocal;
        samsungPayButtonWebComponent.appendChild(samsungPayButton);
        buttonContainer.appendChild(samsungPayButtonWebComponent);
        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.BUTTON_RENDERED);
        return;
    }
    eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.BUTTON_NOT_RENDERED_ALREADY_EXISTS);
};
/** @internal */
var startPaymentImpl = function () { return __awaiter(void 0, void 0, void 0, function () {
    var samsungPayButton;
    return __generator(this, function (_a) {
        if (!paymentRequest) {
            eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.SDK_NOT_INITIALIZED);
            return [2 /*return*/];
        }
        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.PAYMENT_COMPLETION_STARTING);
        samsungPayButton = samsungPayButtonId
            ? document.getElementById(samsungPayButtonId)
            : null;
        setButtonDisabled(samsungPayButton, true);
        paymentRequest
            .show()
            .then(function (paymentResponse) { return __awaiter(void 0, void 0, void 0, function () {
            var samsungPayPaymentResponse, paymentCredentials, token;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        samsungPayPaymentResponse = paymentResponse;
                        paymentCredentials = (_a = samsungPayPaymentResponse.details) === null || _a === void 0 ? void 0 : _a.paymentCredential;
                        token = paymentCredentials ? (_b = paymentCredentials["3DS"]) === null || _b === void 0 ? void 0 : _b.data : undefined;
                        if (!token) return [3 /*break*/, 2];
                        return [4 /*yield*/, processPayment(token, paymentResponse, samsungPayPaymentResponse.shippingAddress, (_d = (_c = samsungPayPaymentResponse.details) === null || _c === void 0 ? void 0 : _c.paymentInfo) === null || _d === void 0 ? void 0 : _d.billingAddress)];
                    case 1:
                        _e.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.PAYMENT_COMPLETION_NOK, "Could not find payment token.");
                        paymentResponse.complete("fail");
                        _e.label = 3;
                    case 3:
                        setButtonDisabled(samsungPayButton, false);
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function (error) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR, error);
                        return [4 /*yield*/, reinitializeSdk()];
                    case 1:
                        _a.sent();
                        setButtonDisabled(samsungPayButton, false);
                        return [2 /*return*/];
                }
            });
        }); });
        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.PAYMENT_COMPLETION_STARTED);
        return [2 /*return*/];
    });
}); };
var processPayment = function (token, paymentResponse, shippingAddress, billingAddress) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!samsungPayInitParamsGlobal || !samsungPayInitParamsGlobal.transactionId) {
                    throw new Error("TransactionId is not defined");
                }
                return [4 /*yield*/, samsungPaySdkService
                        .completePayment(token, samsungPayInitParamsGlobal.transactionId, shippingAddress, billingAddress)
                        .then(function (serverResponse) { return __awaiter(void 0, void 0, void 0, function () {
                        var xRequestId;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    xRequestId = serverResponse.xRequestId;
                                    if (serverResponse.responseJson && serverResponse.responseJson.status === "APPROVED") {
                                        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.PAYMENT_COMPLETION_OK, undefined, xRequestId);
                                        paymentResponse.complete("success");
                                    }
                                    else if (serverResponse.responseJson && serverResponse.responseJson.status === "REQUIRED_3DS") {
                                        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.PAYMENT_COMPLETION_REQUIRED_3DS, serverResponse.responseJson, xRequestId);
                                        paymentResponse.complete("success");
                                    }
                                    else if (!serverResponse.responseJson && serverResponse.error) {
                                        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR, serverResponse.error, serverResponse.xRequestId);
                                        paymentResponse.complete("fail");
                                    }
                                    else {
                                        eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.PAYMENT_COMPLETION_NOK, serverResponse.responseJson, xRequestId);
                                        paymentResponse.complete("fail");
                                    }
                                    return [4 /*yield*/, reinitializeSdk()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .catch(function (error) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR, error, error.xRequestId);
                                    paymentResponse.complete("fail");
                                    return [4 /*yield*/, reinitializeSdk()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var reinitializeSdk = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = samsungPayInitParamsGlobal;
                if (!_a) return [3 /*break*/, 2];
                return [4 /*yield*/, initSdkImpl(samsungPayInitParamsGlobal, SamsungPayEventTypeEnumsObj.SDK_REINITIALIZE_SUCCESS)];
            case 1:
                _a = (_b.sent());
                _b.label = 2;
            case 2:
                _a;
                return [2 /*return*/];
        }
    });
}); };
var setButtonDisabled = function (button, disabled) {
    if (button) {
        button.disabled = disabled;
    }
};
/** @internal */
var isUserEligibleToMakePaymentImpl = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        //TODO
        return [2 /*return*/, true];
    });
}); };
/** @internal */
var samsungPayButtonOnClick = function (userButtonOnClickFunction) {
    eventReporter.sendEvent(SamsungPayEventTypeEnumsObj.BUTTON_CLICK);
    if (typeof userButtonOnClickFunction === "function")
        userButtonOnClickFunction();
    else
        startPaymentImpl();
};
